import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { AppInsightService, LobbyType, LogEvents } from '@rct/lynx-lobbies-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LYNX_STORAGE_KEYS } from '../constants/lynx-storage-keys.constant';
import { LynxAuthService } from '../services/auth.service';

@Injectable()
export class LynxErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: LynxAuthService,
    private appInsightService: AppInsightService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('api')) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (this.authService.isLoggedIn && error.status === 401) {
            this.authService.forceLogout();
            this.appInsightService.logEvent(
              { storageKeys: LYNX_STORAGE_KEYS, lobbyType: LobbyType.Lynx },
              LogEvents['SessionExpired']
            );
            this.appInsightService.gaEvent(
              { storageKeys: LYNX_STORAGE_KEYS, lobbyType: LobbyType.Lynx },
              LogEvents['SessionExpired']
            );
          }

          isDevMode() &&
            console.error('Lynx Error Interceptor Triggered:::', error);

          return throwError(error);
        })
      );
    }
    return next.handle(request);
  }
}
